export default "__VITE_ASSET__OcmtbVmX__"